// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__CHRWp","m":"Timer_m__NnFCq","s":"Timer_s__Fic-D","ms":"Timer_ms__NYHrd"};